module.exports = __webpack_public_path__ + "img/76155.c3c5eb6c.svg";